// FontAwesomeのアイコンはここにあるものしか表示されない
// アイコンを追加するときは、該当アイコンをimportしてからlibrary.addに追加する

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faGlobe,
  faTrashAlt,
  faPlus,
  faCog,
  faAngleLeft,
  faAngleRight,
  faComment as fasComment,
  faComments as fasComments,
  faUserCircle,
  faPlusCircle,
  faPenSquare,
  faAngleDown,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faMapMarkerAlt,
  faTag,
  faNewspaper,
  faLink,
  faBold,
  faItalic,
  faImage,
  faQuestionCircle,
  faUserFriends,
  faStar as fasStar,
  faHands,
  faCheckCircle,
  faCheckSquare,
  faMale,
  faFemale,
  faExclamationTriangle,
  faClipboard,
  faRibbon,
  faCalendarAlt as fasCalendarAlt,
  faUsers,
  faEllipsisH,
  faEllipsisV,
  faCommentDots,
  faHeart,
  faRocket,
  faEnvelope,
  faBan,
  faCaretDown,
  faSignInAlt,
  faWalking,
  faBars,
  faUserPlus,
  faCheck,
  faSortAmountDownAlt,
  faDatabase,
  faCloudUploadAlt,
  faTasks,
  faTicketAlt,
  faSpinner,
  faAlignJustify,
  faShoppingCart,
  faGift,
  faArrowsAltV,
  faThumbsUp as fasThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import {
  faBookmark,
  faThumbsUp as farThumbsUp,
  faTimesCircle,
  faStar as farStar,
  faBell,
  faCopy,
  faComment as farComment,
  faComments as farComments,
  faCommentAlt,
  faUser,
  faCalendarAlt as farCalendarAlt,
} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebook,
  faFacebookF,
  faTwitterSquare,
  faTwitter,
  faInstagramSquare,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faGlobe,
  faTrashAlt,
  faPlus,
  faCog,
  faAngleLeft,
  faAngleRight,
  fasComment,
  fasComments,
  faUserCircle,
  faPlusCircle,
  faPenSquare,
  faAngleDown,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faMapMarkerAlt,
  faTag,
  faNewspaper,
  faLink,
  faBold,
  faItalic,
  faImage,
  faQuestionCircle,
  faUserFriends,
  fasStar,
  faHands,
  faCheckCircle,
  faCheckSquare,
  faMale,
  faFemale,
  faExclamationTriangle,
  faClipboard,
  faRibbon,
  fasCalendarAlt,
  faUsers,
  faEllipsisH,
  faEllipsisV,
  faCommentDots,
  faHeart,
  faRocket,
  faEnvelope,
  faBan,
  faCaretDown,
  faSignInAlt,
  faWalking,
  faBars,
  faUserPlus,
  faCheck,
  faSortAmountDownAlt,
  faDatabase,
  faCloudUploadAlt,
  faTasks,
  faTicketAlt,
  faSpinner,
  faAlignJustify,
  faShoppingCart,
  faGift,
  faArrowsAltV,
  fasThumbsUp,

  faImage,
  faBookmark,
  farThumbsUp,
  faTimesCircle,
  farStar,
  faBell,
  faCopy,
  farComment,
  farComments,
  faCommentAlt,
  faUser,
  farCalendarAlt,

  faFacebook,
  faFacebookF,
  faTwitterSquare,
  faTwitter,
  faInstagramSquare,
  faInstagram,
);
dom.watch();
